export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img4-d2a67bec98f5726b13db42d27d57d9c5.png";